package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2025_01_11_Day_1
import com.veldekar.components.logs.Log_2025_01_11_Day_2
import com.veldekar.components.logs.Log_2025_01_11_Day_3
import com.veldekar.components.widgets.SessionDayHeader
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2025-01-11")
@Composable
public fun Log_2025_01_11(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "🐫🏜️🌵🏜️🌪️🌪️🌪️🌪️🌪️",
        ogTitle = "🐫🏜️🌵🏜️🌪️🌪️🌪️🌪️🌪️",
        date = LocalDate(2_025, 1, 11),
        ogDescription = "As warned by Joral Deetry, the heroes encounter air elementals in Vor’s Desert.",
        ogImage = "ai/2025-01-11.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
    ) {
        SessionDayHeader(dayId = "newgrowth-71", dateString = "Newgrowth 71")
        Log_2025_01_11_Day_1()
        SessionDayHeader(dayId = "newgrowth-72", dateString = "Newgrowth 72")
        Log_2025_01_11_Day_2()
        SessionDayHeader(dayId = "newgrowth-73", dateString = "Newgrowth 73")
        Log_2025_01_11_Day_3()
    }
}
